var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoueCasse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#454d56;}.cls-4{fill:#2e353e;}.cls-5{fill:#b5c5c4;}.cls-6{fill:#c8d9d6;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1769.14,1879.09l-135.36,18.46s-69.38,59.73-77.93,127.15c-18.46,145.61,2.05,186.63,32.81,278.91,4.73,8.64-43.06,14.36-47.16,24.61-.79,2-.08,11.29,4.1,14.36,44.57,32.8,299.37,106.64,334.28,106.64,43.07,0,102.54-6.15,110.75-18.46,5.06-7.59,7.45-29.41-8.21-32.81-47.17-10.25-16.4-83.85-20.5-100.26-25.76-2.71-30.21-5.79-35.25-9.49-6-4.38-8.14-9.49-8.14-16.27-1.35-6.78-33.89-165.39-48.8-204.7-7.72-26.58-17.62-62.36-48.8-105.75-8.6-15.25-16.46-33.17-27.12-50.16C1786.94,1900.37,1778.6,1890.92,1769.14,1879.09Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration 1 roue cass\xE9e") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 2999,
    height: 2999
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\xE9l\\xE9ments_cliquables",
    "data-name": "\\xE9l\\xE9ments cliquables"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1769.14,1879.09l-135.36,18.46s-69.38,59.73-77.93,127.15c-18.46,145.61,2.05,186.63,32.81,278.91,4.73,8.64-43.06,14.36-47.16,24.61-.79,2-.08,11.29,4.1,14.36,44.57,32.8,299.37,106.64,334.28,106.64,43.07,0,102.54-6.15,110.75-18.46,5.06-7.59,7.45-29.41-8.21-32.81-47.17-10.25-16.4-86.13-20.5-102.54-43.07-6.15-28.72-4.1-34.87-8.2s-8.2-8.21-10.25-14.36-30.77-170.22-45.12-205.08S1834.76,1961.12,1769.14,1879.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1551.75,1942.67s37.25-40.41,82-45.12c39-4.1,140.27,76.38,166.12,322,28.71,272.76-112.8,231.74-112.8,231.74L1523,2346.68s12.3-16.41,22.56-20.51,36.91-8.2,36.91-8.2,8.21-4.1,8.21-8.21c0-8.2-59.48-123-59.48-123Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1655.32,
    cy: 2184.66,
    rx: 76.91,
    ry: 184.57,
    transform: "translate(-313.78 277.97) rotate(-8.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1676.44,2113s0-31-36.42-21.48-37.4,77.73-27.84,114.2,30.77,78.66,51.92,75.3c50.68-8,33.55-49.27,33.55-49.27s-1.64,12.19-18.72,16.1-26.54-18.07-32.2-37.46-14.39-62,1.1-84.7S1676.44,2113,1676.44,2113Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8",
    "data-name": "Calque 8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 2999,
    height: 2999
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoueCasse);
export default __webpack_public_path__ + "static/media/roue_casse.f38728e9abdbc92822853627ca96cbaa.svg";
export { ForwardRef as ReactComponent };